import { n as parseForESLint, r as extractEmbeddedCode, t as parse } from "./parse-BrcLn6sq.js";
import "node:module";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region src/ast.ts
var ast_exports = /* @__PURE__ */ __exportAll({});
//#endregion
//#region src/index.ts
var src_default = {
	parse,
	parseForESLint,
	Ast: ast_exports
};
//#endregion
export { ast_exports as Ast, src_default as default, extractEmbeddedCode, parse, parseForESLint };

//# sourceMappingURL=index.js.map